/* tslint:disable */
export var icon = "\n<svg width=\"7\" height=\"7\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0 0l3.5 3.5M7 7L3.5 3.5m0 0L7 0 0 7\" stroke=\"currentColor\"/></svg>\n";
//# sourceMappingURL=medium-thin-x.svg.js.map